import type { SiteContentEntity } from '@common/types/site-content.type';
import type { ShareBlocks } from '@common/types/site.type';
import type { Template } from '@common/types/template.type';
import type { Id, Uuid } from '@common/types';
import type { UnmigratedBlock } from '@web/store/page-structure/page-structure/unmigrated-blocks';

import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ContentActions = createActionGroup({
    source: 'Content',
    events: {
        'Load content': props<{ siteId?: Id | Uuid; pageId: Id | Uuid; template?: Template }>(),
        'Load site content success': props<{ content: SiteContentEntity }>(),
        'Load site content failure': props<{ error: string }>(),
        // `reloadSite` re-fetches the SITE content (shared blocks, theme) instead of reusing the store copy:
        // needed when something outside this browser may have written them.
        'Load page content request': props<{
            siteId: Id | Uuid;
            pageId: Id | Uuid;
            template?: Template;
            reloadSite?: boolean;
        }>(),
        'Load pages content success': props<{ content: SiteContentEntity }>(),
        'Load pages content failure': props<{ error: string }>(),
        // 'Load content from template': props<{ template: Template }>(),
        'Set content': props<{ siteContent: SiteContentEntity; pageContent: SiteContentEntity }>(),
        'Set shared blocks': props<{ blocks: ShareBlocks }>(),
        'Set shared block': props<{ blockId: Uuid; blockType: string }>(),
        'Remove shared block': props<{ blockType: string }>(),
        'Set dirty page id': props<{ pageId: Id | Uuid | string }>(),
        'Set is dirty': props<{ isDirty: boolean }>(),
        'Set is loading': props<{ isLoading: boolean }>(),
        'Set auto save paused': props<{ isPaused: boolean }>(),
        'Set page version': props<{ pageId: Id | Uuid; version: string }>(),
        'Mark page version stale': props<{ pageId: Id | Uuid }>(),
        'Mark page deleted': props<{ pageId: Id | Uuid }>(),
        'Set unmigrated blocks': props<{ blocks: UnmigratedBlock[] }>(),
        'Update page structure content': props<{ structure: string }>(),
        'Update site theme settings content': props<{ themeSettings: string }>(),
        'Update site shared blocks content': props<{ sharedBlocks: ShareBlocks }>(),
        'Reset content to published': emptyProps(),
        'Trigger save content': emptyProps(),
        'Set is reset': props<{ isReset: boolean }>(),
    },
});

export default ContentActions;
